import { action, withoutPayload, withPayload } from '../../../utility/redux';
import { ItemList, ListParams } from '../../../types/main';
import {
  ItemId, Article, Document, Video, VideoRef,
} from '../../../types/items';
import {
  LockMediaToProjectForm,
  MediaFormDocument,
  MediaFormVideo,
} from '../../../types/formItems';
import {
  FormArticle,
  FormHandler,
  UploadMediaItem,
  DocumentDownloadUrl,
  VideoDownloadUrl,
  DownloadMediaState,
  AddDownloadDocument, UploadFromUrlForm, VideoRefSyncResponse,
} from './types';
import { DocumentPage, DocumentPagesPayload } from './types/documentPages';
import {DownloadAll} from "../../../views/projects/actions/DownloadAllMediaAction";

export const initArticleRequest = action(
  'INIT_ARTICLE_REQUEST',
  withoutPayload,
);
export const initArticleSuccess = action(
  'INIT_ARTICLE_SUCCESS',
  withPayload<Article>(),
);
export const initArticleFail = action(
  'INIT_ARTICLE_FAIL',
  withoutPayload,
);

export const createArticleRequest = action(
  'CREATE_ARTICLE_REQUEST',
  withPayload<Article>(),
);
export const createArticleSuccess = action(
  'CREATE_ARTICLE_SUCCESS',
  withPayload<Article>(),
);
export const createArticleFail = action(
  'CREATE_ARTICLE_FAIL',
  withoutPayload,
);

export const getArticleListRequest = action(
  'GET_ARTICLE_LIST_REQUEST',
  withPayload<ListParams>(),
);
export const getArticleListSuccess = action(
  'GET_ARTICLE_LIST_SUCCESS',
  withPayload<ItemList<Article>>(),
);
export const getArticleListFail = action(
  'GET_ARTICLE_LIST_FAIL',
  withoutPayload,
);

export const setArticleListDirty = action(
  'SET_ARTICLE_LIST_DIRTY',
  withPayload<boolean>(),
);

export const getArticleRequest = action(
  'GET_ARTICLE_REQUEST',
  withPayload<ItemId>(),
);
export const getArticleSuccess = action(
  'GET_ARTICLE_SUCCESS',
  withPayload<Article>(),
);
export const getArticleFail = action(
  'GET_ARTICLE_FAIL',
  withoutPayload,
);

export const resetCurrentArticle = action(
  'RESET_CURRENT_ARTICLE',
  withoutPayload,
);

export const saveArticleRequest = action(
  'SAVE_ARTICLE_REQUEST',
  withPayload<Article>(),
);
export const saveArticleSuccess = action(
  'SAVE_ARTICLE_SUCCESS',
  withPayload<Article>(),
);
export const saveArticleFail = action(
  'SAVE_ARTICLE_FAIL',
  withoutPayload,
);

export const deleteArticleRequest = action(
  'DELETE_ARTICLE_REQUEST',
  withPayload<ItemId>(),
);
export const deleteArticleSuccess = action(
  'DELETE_ARTICLE_SUCCESS',
  withPayload<ItemId>(),
);
export const deleteArticleFail = action(
  'DELETE_ARTICLE_FAIL',
  withoutPayload,
);

export const lockMediaToProjectRequest = action(
  'LOCK_MEDIA_TO_PROJECT_REQUEST',
  withPayload<LockMediaToProjectForm>(),
);
export const lockMediaToProjectSuccess = action(
  'LOCK_MEDIA_TO_PROJECT_SUCCESS',
  withPayload<Article>(),
);
export const lockMediaToProjectFail = action(
  'LOCK_MEDIA_TO_PROJECT_FAIL',
  withoutPayload,
);

export const setOpenMediaUpload = action(
  'SET_OPEN_UPLOAD_MEDIA',
  withPayload<boolean>(),
);

export const saveArticleDocumentRequest = action(
  'SAVE_ARTICLE_DOCUMENT_REQUEST',
  withPayload<MediaFormDocument>(),
);
export const saveArticleDocumentSuccess = action(
  'SAVE_ARTICLE_DOCUMENT_SUCCESS',
  withPayload<Document>(),
);
export const saveArticleDocumentFail = action(
  'SAVE_ARTICLE_DOCUMENT_FAIL',
  withoutPayload,
);

export const setArticleForm = action(
  'SET_ARTICLE_FORM',
  withPayload<FormArticle>(),
);

export const setArticleFormsReset = action(
  'SET_ARTICLE_FORMS_RESET',
  withPayload<boolean>(),
);

export const setArticleFormsSubmit = action(
  'SET_ARTICLE_FORMS_SUBMIT',
  withPayload<boolean>(),
);

export const submitArticleForm = action(
  'SUBMIT_ARTICLE_FORM',
  withPayload<FormHandler>(),
);

export const removeArticleForm = action(
  'REMOVE_ARTICLE_FORM',
  withPayload<number>(),
);

export const resetArticleForm = action(
  'RESET_ARTICLE_FORM',
  withPayload<FormHandler>(),
);

export const uploadNewArticleMediaRequest = action(
  'UPLOAD_NEW_ARTICLE_MEDIA_REQUEST',
  withPayload<{title: string; projectId: number; uploadId: string}>(),
);

export const uploadNewArticleVideoRequest = action(
  'UPLOAD_NEW_ARTICLE_VIDEO_REQUEST',
  withPayload<{title: string; projectId: number; uploadId: string; recordedInStudio?: boolean}>(),
);

export const createNewArticleUpload = action(
  'CREATE_NEW_ARTICLE_UPLOAD',
  withPayload<UploadMediaItem>(),
);

export const updateNewArticleUpload = action(
  'UPDATE_NEW_ARTICLE_UPLOAD',
  withPayload<Omit<UploadMediaItem, 'article'>>(),
);

export const uploadNewArticleVideoSuccess = action(
  'UPLOAD_NEW_ARTICLE_VIDEO_SUCCESS',
  withPayload<UploadMediaItem>(),
);
export const removeUploadArticleMedia = action(
  'REMOVE_UPLOAD_ARTICLE_MEDIA',
  withPayload<string>(),
);
export const removeAllUploadArticleMedia = action(
  'REMOVE_ALL_UPLOAD_ARTICLE_MEDIA',
  withoutPayload,
);


export const addDownloadMedia = action(
  'ADD_DOWNLOAD_MEDIA',
  withPayload<DownloadMediaState>(),
);
export const setDownloadMedia = action(
  'SET_DOWNLOAD_MEDIA',
  withPayload<DownloadMediaState>(),
);
export const removeDownloadMedia = action(
  'REMOVE_DOWNLOAD_MEDIA',
  withPayload<string>(),
);
export const removeAllDownloadMedia = action(
  'REMOVE_ALL_DOWNLOAD_MEDIA',
  withoutPayload,
);

export const addDocumentDownloadRequest = action(
  'ADD_DOCUMENT_DOWNLOAD_REQUEST',
  withPayload<AddDownloadDocument>(),
);

export const uploadArticleMediaSuccess = action(
  'UPLOAD_ARTICLE_MEDIA_SUCCESS',
  withPayload<string>(),
);

export const updateRefVideoRef = action(
  'UPDATE_REF_VIDEO_REF',
  withPayload<VideoRefSyncResponse>(),
);

export const updateRefDocumentRef = action(
  'UPDATE_REF_DOCUMENT_REF',
  withPayload<Document>(),
);

export const clearArticleList = action(
  'CLEAR_ARTICLE_LIST',
  withoutPayload,
);

export const clearArticleState = action(
  'CLEAR_ARTICLE_STATE',
  withoutPayload,
);

export const getArticleDocumentDownloadUrlRequest = action(
  'GET_ARTICLE_DOCUMENT_DOWNLOAD_URL_REQUEST',
  withPayload<number>(),
);

export const getArticleDocumentDownloadUrlSuccess = action(
  'GET_ARTICLE_DOCUMENT_DOWNLOAD_URL_SUCCESS',
  withPayload<DocumentDownloadUrl>(),
);
export const getArticleDocumentDownloadUrlFail = action(
  'GET_ARTICLE_DOCUMENT_DOWNLOAD_URL_FAIL',
  withoutPayload,
);

export const getArticleDocumentPagesRequest = action(
  'GET_ARTICLE_DOCUMENT_PAGES_REQUEST',
  withPayload<number>(),
);

export const getArticleDocumentPagesSuccess = action(
  'GET_ARTICLE_DOCUMENT_PAGES_SUCCESS',
  withPayload<DocumentPagesPayload>(),
);

export const getArticleDocumentPagesFail = action(
  'GET_ARTICLE_DOCUMENT_PAGES_FAIL',
  withoutPayload,
);

export const setCurrentArticleDocumentPage = action(
  'SET_CURRENT_ARTICLE_DOCUMENT_PAGE',
  withPayload<DocumentPage>(),
);

export const setNextArticleDocumentPage = action(
  'SET_NEXT_ARTICLE_DOCUMENT_PAGE',
  withoutPayload,
);

export const setPreviousArticleDocumentPage = action(
  'SET_PREVIOUS_ARTICLE_DOCUMENT_PAGE',
  withoutPayload,
);


export const getArticleVideoDownloadUrlRequest = action(
  'GET_ARTICLE_VIDEO_DOWNLOAD_URL_REQUEST',
  withPayload<number>(),
);
export const getArticleVideoDownloadUrlSuccess = action(
  'GET_ARTICLE_VIDEO_DOWNLOAD_URL_SUCCESS',
  withPayload<VideoDownloadUrl>(),
);
export const getArticleVideoDownloadUrlFail = action(
  'GET_ARTICLE_VIDEO_DOWNLOAD_URL_FAIL',
  withoutPayload,
);

export const setOpenMediaViewer = action(
  'SET_OPEN_ARTICLE_MEDIA_VIEWER',
  withPayload<boolean>(),
);

export const setCurrentIndexMediaViewer = action(
  'SET_CURRENT_INDEX_ARTICLE_MEDIA_VIEWER',
  withPayload<number>(),
);

export const setCurrentDocumentPageIndexMediaViewer = action(
  'SET_CURRENT_DOCUMENT_PAGE_INDEX_ARTICLE_MEDIA_VIEWER',
  withPayload<number>(),
);

export const getArticleVideoMasterRequest = action(
  'GET_ARTICLE_VIDEO_MASTER_REQUEST',
  withPayload<VideoRef>(),
);

export const getArticleVideoMasterSuccess = action(
  'GET_ARTICLE_VIDEO_MASTER_SUCCESS',
  withoutPayload,
);

export const getArticleVideoMasterFail = action(
  'GET_ARTICLE_VIDEO_MASTER_FAIL',
  withoutPayload,
);

export const getArticleVideoRequest = action(
  'GET_ARTICLE_VIDEO_REQUEST',
  withPayload<number>(),
);
export const getArticleVideoSuccess = action(
  'GET_ARTICLE_VIDEO_SUCCESS',
  withPayload<Video>(),
);
export const getArticleVideoFail = action(
  'GET_ARTICLE_VIDEO_FAIL',
  withoutPayload,
);

export const saveArticleVideoRequest = action(
  'SAVE_ARTICLE_VIDEO_REQUEST',
  withPayload<MediaFormVideo>(),
);
export const saveArticleVideoSuccess = action(
  'SAVE_ARTICLE_VIDEO_SUCCESS',
  withPayload<Video>(),
);
export const saveArticleVideoFail = action(
  'SAVE_ARTICLE_VIDEO_FAIL',
  withoutPayload,
);

export const setRefreshArticleList = action(
  'SET_REFRESH_ARTICLES_LIST',
  withPayload<boolean>(),
);

export const getArticleListRefreshRequest = action(
  'GET_ARTICLE_LIST_REFRESH_REQUEST',
  withPayload<ListParams>(),
);
export const getArticleListRefreshSuccess = action(
  'GET_ARTICLE_LIST_REFRESH_SUCCESS',
  withPayload<ItemList<Article>>(),
);

export const saveVideoThumbnailRequest = action(
  'SAVE_VIDEO_THUMBNAIL_REQUEST',
  withPayload<MediaFormVideo>(),
);
export const saveVideoThumbnailSuccess = action(
  'SAVE_VIDEO_THUMBNAIL_SUCCESS',
  withPayload<Video>(),
);

export const setOpenModalExportMedia = action(
  'SET_OPEN_MODAL_EXPORT_MEDIA',
  withPayload<boolean>(),
);
export const setDataExportMedia = action(
  'SET_DATA_EXPORT_MEDIA',
  withPayload<Article>(),
);

export const updateProcessingMediaArticleRequest = action(
  'UPDATE_PROCESSING_MEDIA_ARTICLE_REQUEST',
  withPayload<Article>(),
);

export const updateProcessingMediaArticleSuccess = action(
  'UPDATE_PROCESSING_MEDIA_ARTICLE_SUCCESS',
  withPayload<Article>(),
);

export const updateProcessingMediaArticleFail = action(
  'UPDATE_PROCESSING_MEDIA_ARTICLE_REQUEST',
  withoutPayload,
);

export const downloadAllMedia = action(
  'DOWNLOAD_ALL_MEDIA',
  withPayload<DownloadAll>(),
);

export const uploadMediaFromURLRequest = action(
  'UPLOAD_MEDIA_FROM_URL_REQUEST',
  withPayload<UploadFromUrlForm>(),
);

export const uploadMediaFromURLSuccess = action(
  'UPLOAD_MEDIA_FROM_URL_SUCCESS',
  withoutPayload,
);

export const uploadMediaFromURLFail = action(
  'UPLOAD_MEDIA_FROM_URL_FAIL',
  withoutPayload,
);

export const uploadMediaFromURLInitial = action(
  'UPLOAD_MEDIA_FROM_URL_INITIAL',
  withPayload<UploadFromUrlForm>(),
);
